export enum FileType {
  IMAGE = 'image',
  PDF = 'pdf',
  WORD = 'word_document',
  EXCEL = 'excel',
  POWERPOINT = 'powerpoint',
  VIDEO = 'video',
  TEXT = 'text',
  ARCHIVE = 'archive',
  EMAIL = 'email',
  EMAIL_ATTACH = 'email_with_attachments',
  CAD_DRAWING = 'cad_drawing',
  BIM = 'bim',
  UNKNOWN = 'unknown',
  MULTIPLE_FILES_TYPES = 'multiple_file_types',
  PANORAMA = '360_image',
  FOLDER = 'folder',
}

export const FILE_TYPE_ICON_MAP: Record<FileType, string> = {
  [FileType.IMAGE]: '_file_type_image',
  [FileType.PDF]: '_file_type_pdf',
  [FileType.WORD]: '_file_type_word',
  [FileType.EXCEL]: '_file_type_excel',
  [FileType.POWERPOINT]: '_file_type_powerpoint',
  [FileType.VIDEO]: '_file_type_video',
  [FileType.TEXT]: '_file_type_txt',
  [FileType.ARCHIVE]: '_file_type_zip',
  [FileType.EMAIL]: '_file_type_email',
  [FileType.EMAIL_ATTACH]: '_file_type_attach_email',
  [FileType.CAD_DRAWING]: '_file_type_cad',
  [FileType.BIM]: '_bim-model',
  [FileType.UNKNOWN]: '_file_type_unknown',
  [FileType.MULTIPLE_FILES_TYPES]: '_file_type_multi',
  [FileType.PANORAMA]: '_file_type_image_360',
  [FileType.FOLDER]: 'folder',
};

export interface ThumbnailSize {
  width: string;
  height: string;
}

export function getOfficeFileType(value: string): FileType | undefined {
  const type = value.toLowerCase();
  const extension = type.replace(/^\./, '');
  if (
    /^(doc|docx|docm|dot|dotx|dotm|odt|ott)$/.test(extension) ||
    /^application\/(msword|vnd\.ms-word\..+|vnd\.openxmlformats-officedocument\.wordprocessingml\..+|vnd\.oasis\.opendocument\.text(?:-template)?)$/.test(type)
  ) {
    return FileType.WORD;
  }
  if (
    /^(xls|xlsx|xlsm|xlsb|xlt|xltx|xltm|csv|ods|ots)$/.test(extension) ||
    /^application\/(vnd\.ms-excel(?:\..+)?|vnd\.openxmlformats-officedocument\.spreadsheetml\..+|vnd\.oasis\.opendocument\.spreadsheet(?:-template)?)$/.test(type)
  ) {
    return FileType.EXCEL;
  }
  if (
    /^(ppt|pptx|pptm|pps|ppsx|ppsm|pot|potx|potm|odp|otp)$/.test(extension) ||
    /^application\/(vnd\.ms-powerpoint(?:\..+)?|vnd\.openxmlformats-officedocument\.presentationml\..+|vnd\.oasis\.opendocument\.presentation(?:-template)?)$/.test(type)
  ) {
    return FileType.POWERPOINT;
  }
  return undefined;
}
